import axios from 'axios';
import { headers, STOCK } from '../../config';

function search() {
    return axios.get(`${STOCK}/item-account-type`, { headers: headers() });
}
export default {
    search
}